// NOTE: 數量select option (-1 代表無限制)
export const LIMIT_AMOUNT_OPTIONS = [
  ...Array.from({ length: 20 }, (_, i) => i + 1),
  -1,
]
